import { Typography } from 'antd'
import { DndActionIcon } from 'src/assets/icons'
// import './index.scss'

interface IDNDItem {
  item: {
    id: string
    pageName: string
    isFavorite?: boolean
  }
}

export default function DNDItem({ item }: IDNDItem) {
  return (
    <div className='action-container'>
      <DndActionIcon />
      <Typography.Text style={{ fontSize: '14px' }}>{item.pageName}</Typography.Text>
    </div>
  )
}
